// ============================================================================
// MATRIX CHAIN - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'matrix-chain',
  name: 'Matrix Chain Multiplication',
  category: 'Dynamic Programming',
  complexity: {
    time: 'O(N³)',
    space: 'O(N²)'
  },
  description: 'Given a chain of matrices, finds the optimal way to parenthesize the multiplication to minimize the total number of scalar multiplications. Uses DP to compute optimal costs for subchains and builds the solution bottom-up.'
};
